exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.profile-settings[data-v-4d4df953]{height:100%}div.content[data-v-4d4df953]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}", ""]);

// exports
